import React    from 'react';
import history from 'dashboard/history'
import Icon     from 'components/Icon/Icon.react';
import styles   from 'components/Sidebar/Sidebar.scss';

let SidebarSection = ({ active, children, name, link, icon, style, newFeature, betaFeature }) => {
  let classes = [styles.section];

  if (active) {
    classes.push(styles.active);
  }
  if (!children) {
    classes.push(styles.noChildren);
  }

  let iconContent = null;
  if (icon) {
    iconContent = <Icon width={18} height={18} name={icon} />;
  }

  let section_header_classes = [styles.section_header];
  let section_contents_classes = [styles.section_contents];

  if(newFeature) {
    section_header_classes.push(styles.hover)
  }

  const onClickHandler = (e) => {
    e.preventDefault();
    history.push({ pathname: link || '#' });
  }

  return (
    <div className={classes.join(' ')}>
      <a href={link || '#' } style={style} className={section_header_classes.join(' ')} onClick={(e) => onClickHandler(e)}>
        {
          newFeature
            ? <span className={styles.newFeature}></span>
            : null
        }

        {iconContent}

        <span>{name}{betaFeature ? <span>BETA</span>: ''}</span>
      </a>

      {children ? <div className={section_contents_classes.join(' ')}>{children}</div> : null}
    </div>
  );
};

export default SidebarSection;
